if (!customElements.get('learn-collage')) {
  customElements.define(
    'learn-collage',
    class LearnCollage extends HTMLElement {
      constructor() {
        super()
        this.media = this.querySelectorAll('[data-media-index]')
        this.texts = this.querySelectorAll('[data-text-index]')
        this.prevBtns = this.querySelectorAll('[data-prev-slide]')
        this.nextBtns = this.querySelectorAll('[data-next-slide]')
        this.mediaCount = parseInt(this.dataset.mediaCount)
        this.initEvents()
      }

      initEvents() {
        this.swiper = new Swiper(this.querySelector('[data-media-swiper]'), {
          speed: 500,
          effect: 'fade',
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        })
        this.swiper.on('slideChange', () => {
          this.media.forEach((m) => {
            const idx = parseInt(m.dataset.mediaIndex)
            if (idx != this.swiper.activeIndex) this.deactivateMedia(idx)
          })
          this.activateMedia(this.swiper.activeIndex)
        })
        if (this.prevBtns.length > 0 && this.prevBtns.length > 0) {
          this.prevBtns.forEach((prevBtn) => {
            prevBtn.addEventListener('click', (e) => {
              this.swiper.slidePrev()
              if (this.querySelector('.swiper-button-prev').classList.contains('swiper-button-disabled')) {
                this.prevBtns.forEach((btn) => {
                  btn.classList.add('opacity-60', 'pointer-events-none')
                })
              }
              this.nextBtns.forEach((btn) => {
                btn.classList.remove('opacity-60', 'pointer-events-none')
              })
            })
          })
          this.nextBtns.forEach((nextBtn) => {
            nextBtn.addEventListener('click', (e) => {
              this.swiper.slideNext()
              if (this.querySelector('.swiper-button-next').classList.contains('swiper-button-disabled')) {
                this.nextBtns.forEach((btn) => {
                  btn.classList.add('opacity-60', 'pointer-events-none')
                })
              }
              this.prevBtns.forEach((btn) => {
                btn.classList.remove('opacity-60', 'pointer-events-none')
              })
            })
          })
        }
        this.media.forEach((media) => {
          media.addEventListener('click', (e) => {
            const index = parseInt(media.dataset.mediaIndex)
            this.media.forEach((m) => {
              const idx = parseInt(m.dataset.mediaIndex)
              if (idx != index) this.deactivateMedia(idx)
            })
            this.activateMedia(index)
            this.swiper.slideTo(index, 300)
          })
        })
        this.texts.forEach((text) => {
          text.addEventListener('click', (e) => {
            const index = parseInt(text.dataset.textIndex)
            this.media.forEach((m) => {
              const idx = parseInt(m.dataset.mediaIndex)
              if (idx != index) this.deactivateMedia(idx)
            })
            this.activateMedia(index)
            this.swiper.slideTo(index, 300)
          })
        })
        this.activateMedia(0)
      }

      activateMedia(index) {
        const media = this.querySelector(`[data-media-index="${index}"]`)
        if (media) {
          const mediaType = media.dataset.mediaType
          const textIndicator = this.querySelector(`[data-text-index="${index}"]`)
          if (mediaType == 'video') media.querySelector('video').play()
          if (this.mediaCount > 2) {
            media.classList.remove('grayscale', 'pb-70')
            media.classList.add('pb-full')
          } else {
            media.classList.remove('grayscale', 'pb-[47%]')
            media.classList.add('pb-[63%]')
          }

          media.classList.add('z-[1]')
          textIndicator.classList.remove('opacity-40')

          this.prevBtns.forEach((btn) => {
            btn.classList.remove('opacity-60', 'pointer-events-none')
          })
          this.nextBtns.forEach((btn) => {
            btn.classList.remove('opacity-60', 'pointer-events-none')
          })
          if (this.querySelector('.swiper-button-prev').classList.contains('swiper-button-disabled')) {
            this.prevBtns.forEach((btn) => {
              btn.classList.add('opacity-60', 'pointer-events-none')
            })
          }
          if (this.querySelector('.swiper-button-next').classList.contains('swiper-button-disabled')) {
            this.nextBtns.forEach((btn) => {
              btn.classList.add('opacity-60', 'pointer-events-none')
            })
          }
        }
      }
      deactivateMedia(index) {
        const media = this.querySelector(`[data-media-index="${index}"]`)
        if (media) {
          const textIndicator = this.querySelector(`[data-text-index="${index}"]`)
          const mediaType = media.dataset.mediaType
          if (mediaType == 'video') media.querySelector('video').pause()
          if (this.mediaCount > 2) {
            media.classList.add('grayscale', 'pb-70')
            media.classList.remove('pb-full')
          } else {
            media.classList.add('grayscale', 'pb-[47%]')
            media.classList.remove('pb-[63%]')
          }

          media.classList.remove('z-[1]')
          textIndicator.classList.add('opacity-40')
        }
      }
    },
  )
}
